export default __webpack_public_path__ + "static/media/1625.978af255.png";